import styled from "styled-components";

export const FlexBoxRow = styled.div`
  display: flex;
  flex-direction: row;
`;
